{
  "info": "Информация",
  "negative": "Грешка",
  "notice": "Предупреждение",
  "positive": "Успешно"
}
